import * as React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


type Props = {

}
export const InvalidMessage: React.FC<Props> = (props) => {
  const nav = useNavigate();
  const [t, i18n] = useTranslation();


  const InvalidMessageH1 = styled.p`
    font-weight: bold;
    font-size: 17px;
    line-height: 30px;
    color: #FFB16A;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    padding-top: 30px;
  `;
  return (
    <div id="messege">
        <InvalidMessageH1>{t(`無効な配布ページです`)}</InvalidMessageH1>
    </div>
  );
};